export default {
    namespaced: true,
    state: () => ({
        coords: {
            from: 0,
            to: 0,
            loader: {
                x: 0,
                y: 0,
            },
            input: 0,
        },
        originalText: '',
        originalHTML: '',
        originalPrompt: {
            task: '',
            tone: null,
            language: null,
            userInput: null,
            write: null,
        },
        typeRichText: '',
        source: null,
        cancelAIGeneration: false,
        controller: new AbortController(),
        useAI: false,
        showLoader: false,
        isLoading: false,
        editor: null,
        uuid: null,
        outputAI: '',
        template: null,
    }),
    mutations: {
        setCoords(state, payload) {
            state.coords = {
                ...state.coords,
                ...payload,
            };
        },
        setOriginalHTML(state, payload) {
            state.originalHTML = payload;
        },
        setOriginalText(state, payload) {
            state.originalText = payload;
        },
        setOriginalPrompt(state, payload) {
            state.originalPrompt = payload;
        },
        setTypeRichText(state, payload) {
            state.typeRichText = payload;
        },
        setSource(state, payload) {
            state.source = payload;
        },
        setCancelAIGeneration(state, payload) {
            state.cancelAIGeneration = payload;
        },
        setController(state) {
            state.controller = new AbortController();
        },
        setUseAI(state, payload) {
            state.useAI = payload;
        },
        setShowLoader(state, payload) {
            state.showLoader = payload;
        },
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setEditor(state, payload) {
            state.editor = payload;
        },
        setUuid(state, payload) {
            state.uuid = payload;
        },
        setOutputAI(state, payload) {
            state.outputAI = payload;
        },
        setTemplate(state, payload) {
            state.template = payload;
        },
    },
    actions: {
        setCoords({ commit }, payload) {
            commit('setCoords', payload);
        },
        setOriginalHTML({ commit }, payload) {
            commit('setOriginalHTML', payload);
        },
        setOriginalText({ commit }, payload) {
            commit('setOriginalText', payload);
        },
        setOriginalPrompt({ commit }, payload) {
            commit('setOriginalPrompt', payload);
        },
        setTypeRichText({ commit }, payload) {
            commit('setTypeRichText', payload);
        },
        setSource({ commit }, payload) {
            commit('setSource', payload);
        },
        setCancelAIGeneration({ commit }, payload) {
            commit('setCancelAIGeneration', payload);
        },
        setController({ commit }) {
            commit('setController');
        },
        setUseAI({ commit }, payload) {
            commit('setUseAI', payload);
        },
        setShowLoader({ commit }, payload) {
            commit('setShowLoader', payload);
        },
        setIsLoading({ commit }, payload) {
            commit('setIsLoading', payload);
        },
        setEditor({ commit }, payload) {
            commit('setEditor', payload);
        },
        setUuid({ commit }, payload) {
            commit('setUuid', payload);
        },
        setOutputAI({ commit }, payload) {
            commit('setOutputAI', payload);
        },
        setTemplate({ commit }, payload) {
            commit('setTemplate', payload);
        },
    },
};
